export const ANALYTICS_EVENTS = {
  PAGE_VIEW: 'page_view',

  VIEW_ITEM_LIST: 'view_item_list',

  SELECT_ITEM: 'select_item',

  VIEW_ITEM: 'view_item',

  ADD_TO_CART: 'add_to_cart',

  REMOVE_FROM_CART: 'remove_from_cart',

  BEGIN_CHECKOUT: 'begin_checkout',

  FORM_START: 'form_start',

  FORM_START_CHECKOUT: 'form_start_checkout',

  ADD_SHIPPING_INFO: 'add_shipping_info',

  LOGIN: 'login',

  LOGOUT: 'logout',

  UPSELL_SELECTED: 'upsell_selected',

  UPSELL_DESELECTED: 'upsell_deselected',

  RAINOUT_INSURANCE_TOGGLED: 'rainout_insurance_toggled',

  DISCOUNT_APPLIED: 'discount_applied',

  ADD_PAYMENT_INFO: 'add_payment_info',

  CHECKOUT_COMPLETED: 'checkout_completed',

  PURCHASE: 'purchase',

  UPGRADE_SHOWN: 'upgrade_shown',

  UPGRADE_ACQUIRED: 'upgrade_acquired',

  ADLINK_CLICK: 'adlink_click',

  TRANSACTION_CANCELLED: 'transaction_cancelled',

  CHECKOUT_FORM_INVALID: 'checkout_form_invalid',

  CHECKOUT_VALIDATION_ERROR: 'checkout_validation_error',

  CHECKOUT_ERROR: 'checkout_error',

  SEAT_SELECTION_ERROR: 'seat_selection_error',

  EVENT_LOAD_ERROR: 'event_load_error',

  PAYMENT_ERROR: 'payment_error',

  PAYMENT_TIMEOUT: 'payment_timeout',

  CART_ABANDONED: 'cart_abandoned',

  CHECKOUT_ABANDONED: 'checkout_abandoned',

  CHECKOUT_BACK: 'checkout_back',
} as const;

export const ANALYTICS_LIST_NAMES = {
  EVENTS: 'events',
} as const;

export const ANALYTICS_ITEM_CATEGORIES = {
  GAME: 'game',
  SEATS: 'seats',
  UPSELL: 'upsell',
  RAINOUT_INSURANCE: 'rainout_insurance',
} as const;

export const ANALYTICS_SCREENS = {
  EVENTS_LIST: 'events_list',
  SEAT_SELECTION: 'seat_selection',
  CHECKOUT: 'checkout',
  CHECKOUT_CONFIRMATION: 'checkout_confirmation',
  UNKNOWN: 'unknown',
} as const;

export const ANALYTICS_JOURNEY_ORIGINS = {
  EVENTS_LIST: 'events_list',
  GROUP_LINK: 'group_link',
} as const;

export const ANALYTICS_FORMS = {
  CHECKOUT: 'checkout',
} as const;

export const ANALYTICS_ABANDON_OWNERS = {
  CART: 'cart',
  CHECKOUT: 'checkout',
} as const;

export const ANALYTICS_CANCEL_REASONS = {
  CHECKOUT_BACK: 'checkout_back',
  CART_EXPIRED: 'cart_expired',
  TRANSACTION_NOT_FOUND: 'transaction_not_found',
  PATRON_ASSOCIATION_ERROR: 'patron_association_error',
  UPSELL_CHANGE_ERROR: 'upsell_change_error',
  UNKNOWN: 'unknown',
} as const;

export const ANALYTICS_MAX_ERROR_MESSAGE_LENGTH = 100;

export const ANALYTICS_MAX_PARAMETER_VALUE_LENGTH = 100;
